<template>
  <div class="event-summary smooth-shadow">
    <div class="header">
      <h2 class="title">Event Summary</h2>
      <!-- <DecoupledDateFrequencyPicker @saveTimeFilters="saveTimeFilters" /> -->
    </div>
    <div
      class="event-summary-grid"
      :style="{
        gridTemplateRows: `repeat(${numberOfColumns}, 1fr)`,
      }"
    >
      <!-- <div class="event-summary-col"> -->
      <div
        v-for="(item, i) in processedData"
        :key="i"
        :class="['data-item', { active: col_filter.value === item.name }]"
        @click.prevent="toggleFilter(item.name)"
      >
        <div class="meta-row">
          <p class="title">{{ item.name || "null" }}</p>
          <p>{{ item.count }}</p>
        </div>
        <div :class="['progress-track']">
          <div
            :class="[
              'progress-thumb',
              { active: col_filter.value === item.name },
            ]"
            :style="`width: ${item.percentage}%`"
          ></div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import DecoupledDateFrequencyPicker from "@/components/datetimepicker/DecoupledDateFrequencyPicker";

export default {
  components: {
    DecoupledDateFrequencyPicker,
  },
  props: {
    data: Array,
    total_events: Number,
    col_filter: Object,
  },
  data() {
    return {};
  },
  computed: {
    processedData() {
      return this.data
        .map((item) => ({
          name: item.event_name,
          count: item.event_count,
          percentage: (item.event_count / this.total_events) * 100,
        }))
        .sort((a, b) => b.percentage - a.percentage);
    },
    numberOfColumns() {
      if (this.processedData.length <= 6) return this.processedData.length;
      if (this.processedData.length <= 12)
        return Math.ceil(this.processedData.length / 2);
      else return Math.ceil(this.processedData.length / 3);
    },
  },
  methods: {
    saveTimeFilters(timeFilters) {
      this.$emit("saveTimeFilters", timeFilters);
    },
    toggleFilter(value) {
      // this.$emit("selectFilter", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.event-summary {
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--border-color);
  padding: 15px 25px;

  .header {
    display: flex;
    align-items: center;

    .title {
      font-weight: bold;
      margin: 20px 0;
      margin-right: 50px;
    }
  }

  .event-summary-grid {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* grid-gap: 24px; */
    /* grid-template-rows: repeat(6, 1fr); */
    column-gap: 24px;
    grid-auto-flow: column;

    /* .event-summary-col {
      display: flex;
      flex-direction: column;
      padding: 10px 0;
    } */

    .data-item {
      display: flex;
      flex-direction: column;
      min-height: 50px;
      margin: 0 15px;
      /* cursor: pointer; */
      transition: 0.2s all ease-in-out;

      .meta-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;

        p {
          margin: 0;
          padding: 0;
        }
        .title {
          flex: 1;
        }
      }

      &.active {
        color: var(--color-primary);
        font-weight: bold;
        .progress-track .progress-thumb {
          background-color: var(--font-color);
        }
      }

      /* &:hover {
          .progress-track {
            .progress-thumb {
              background-color: var(--color-accent);
              opacity: 1;
            }
          }
        } */

      .progress-track {
        position: relative;
        background-color: var(--border-color);
        min-height: 6px;
        border-radius: 10px;
        margin-top: 5px;

        .progress-thumb {
          position: absolute;
          left: 0;
          min-height: 6px;
          border-radius: 10px;
          background-color: var(--font-color);
          opacity: 0.5;

          &.active {
            background-color: var(--color-accent);
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
